import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Mail, Loader2, Building2, Phone } from "lucide-react";

export default function Messages() {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  const load = useCallback(() => api.get("/contact/messages").then(({ data }) => setMsgs(data)).catch((e) => console.error(e)).finally(() => setLoading(false)), []);
  useEffect(() => { load(); }, [load]);

  const open = async (m) => {
    setActive(m);
    if (m.status === "new") { await api.patch(`/contact/messages/${m.id}?status=read`).catch(() => {}); load(); }
  };

  if (loading) return <div className="grid place-items-center py-20 text-teal-400"><Loader2 className="w-8 h-8 animate-spin" /></div>;

  return (
    <div>
      <div className="mb-8"><h1 className="text-2xl sm:text-3xl font-extrabold text-[#0B3B39]">Contact Messages</h1><p className="text-slate-600 mt-1">{msgs.length} total enquiries received.</p></div>
      {msgs.length === 0 ? (
        <div className="oj-card p-12 text-center text-slate-500"><Mail className="w-10 h-10 mx-auto mb-3 opacity-50" />No messages yet.</div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1 space-y-3 max-h-[70vh] overflow-y-auto pr-1">
            {msgs.map((m) => (
              <button key={m.id} onClick={() => open(m)} data-testid={`message-${m.id}`} className={`w-full text-left oj-card p-4 ${active?.id === m.id ? "!border-amber-400/50" : ""}`}>
                <div className="flex items-center justify-between"><span className="font-semibold text-white text-sm truncate">{m.name}</span>{m.status === "new" && <span className="w-2 h-2 rounded-full bg-amber-400" />}</div>
                <div className="text-xs text-slate-600 truncate mt-0.5">{m.subject}</div>
                <div className="text-[10px] text-slate-600 font-mono mt-1">{new Date(m.created_at).toLocaleDateString()}</div>
              </button>
            ))}
          </div>
          <div className="lg:col-span-2">
            {active ? (
              <div className="oj-card p-7" data-testid="message-detail">
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div><h3 className="text-xl font-bold text-white">{active.subject}</h3><div className="text-sm text-slate-600 mt-1">{active.name} • {active.email}</div></div>
                  <span className="px-2.5 py-1 rounded-md text-[10px] font-mono uppercase bg-teal-50 text-teal-700 border border-teal-200 capitalize">{active.vertical}</span>
                </div>
                <div className="flex flex-wrap gap-4 text-xs text-slate-600 mb-5 pb-5 border-b border-teal-900/40">
                  {active.company && <span className="flex items-center gap-1.5"><Building2 className="w-3.5 h-3.5 text-teal-400" /> {active.company}</span>}
                  {active.phone && <span className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5 text-teal-400" /> {active.phone}</span>}
                </div>
                <p className="text-slate-600 leading-relaxed whitespace-pre-wrap">{active.message}</p>
                <a href={`mailto:${active.email}`} className="oj-btn-gold mt-6 !py-2.5 !px-5 !text-sm inline-flex"><Mail className="w-4 h-4" /> Reply via Email</a>
              </div>
            ) : <div className="oj-card p-12 text-center text-slate-500">Select a message to read.</div>}
          </div>
        </div>
      )}
    </div>
  );
}
